import { isNonNullable } from '../isNonNullable/isNonNullable.js';
import { isString } from '../isString/isString.js';
import { isSubscription } from '../logger/subscriptions.js';

const SEPARATOR = ":";
const serialise = ({ subscription, name, action }) => [subscription, name, action].filter(isNonNullable).join(SEPARATOR);
const deserialise = (id) => {
  const [subscription, name, action] = id.split(SEPARATOR);
  return isString(subscription) && isSubscription(subscription) && isString(name) ? { subscription, name, action } : void 0;
};

export { deserialise, serialise };
